var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid fx_ctr h__fixed scrollable pagebox"},[_c('div',{staticClass:"listcon mcol h__fixed scroll__y menus"},[_c('h1',{staticClass:"title spacing"},[_vm._v("Settings")]),_c('McolMenu',{attrs:{"menus":_vm.menus}})],1),_c('div',{staticClass:"stage mcon h__fixed scroll__y page"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }